import {
  SpiddDraftMatch,
  SpiddDraftMatchStatus,
} from "../../types/SpiddDraftMatch";

/** Statuts encore à traiter (masque approuvées / associées / ignorées / obsolètes). */
export const ACTIVE_DRAFT_STATUSES: SpiddDraftMatchStatus[] = [
  "PROPOSED",
  "NEEDS_REVIEW",
];

export type SpiddDraftFilters = {
  tableauId: string;
  phase: string;
  poolId: string;
  status: SpiddDraftMatchStatus | "ALL" | "ACTIVE" | "CONFLICT";
  query: string;
};

export const defaultSpiddDraftFilters: SpiddDraftFilters = {
  tableauId: "",
  phase: "",
  poolId: "",
  status: "ACTIVE",
  query: "",
};

export function filterSpiddDrafts(
  drafts: SpiddDraftMatch[],
  filters: SpiddDraftFilters,
  options?: {
    /** Texte additionnel de recherche (ex. noms de joueurs, libellé tableau). */
    getSearchText?: (draft: SpiddDraftMatch) => string;
  }
): SpiddDraftMatch[] {
  const q = filters.query.trim().toLowerCase();
  return drafts.filter((d) => {
    if (filters.tableauId && d.sourceTableauId !== filters.tableauId) {
      return false;
    }
    if (filters.phase && d.sourcePhaseId !== filters.phase) return false;
    if (filters.poolId && d.sourcePoolId !== filters.poolId) return false;
    if (filters.status === "CONFLICT") {
      if (d.matchSuggestion !== "CONFLICT") return false;
    } else if (filters.status === "ACTIVE") {
      if (!ACTIVE_DRAFT_STATUSES.includes(d.status)) return false;
    } else if (filters.status !== "ALL" && d.status !== filters.status) {
      return false;
    }
    if (!q) return true;
    const hay = [
      ...d.playerLicences,
      ...(d.playerIds || []).filter(Boolean),
      d.sourcePoolId,
      d.meta?.poolLabel,
      d.meta?.roundLabel,
      d.firestoreTableauId,
      d.sourceTableauId,
      options?.getSearchText?.(d),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return hay.includes(q);
  });
}

/** Propositions éligibles à une création en masse (sans anomalie bloquante). */
export function isBatchCreatable(draft: SpiddDraftMatch): boolean {
  if (draft.status !== "PROPOSED") return false;
  if (draft.matchSuggestion === "CONFLICT") return false;
  if (draft.matchSuggestion === "LINK") return false;
  if (!draft.firestoreTableauId || !draft.firestoreTourId) return false;
  if ((draft.playerIds || []).some((id) => !id)) return false;
  const blocking = (draft.anomalies || []).some((a) =>
    [
      "PLAYER_NOT_FOUND",
      "AMBIGUOUS_LICENCE",
      "BOARD_MAPPING_MISSING",
      "BOARD_MAPPING_AMBIGUOUS",
      "TOUR_UNRESOLVED",
      "TOUR_MAPPING_AMBIGUOUS",
      "MISSING_LICENCE",
      "MULTIPLE_MATCH_CANDIDATES",
    ].includes(a.code)
  );
  return !blocking;
}

/** Propositions dont le mapping tableau/tour peut être corrigé avant création. */
export function isRemappable(draft: SpiddDraftMatch): boolean {
  if (draft.operationalMatchId) return false;
  return draft.status === "PROPOSED" || draft.status === "NEEDS_REVIEW";
}
